export default __webpack_public_path__ + "static/media/withdraw-icon.f808235e.webp";